import { t } from 'i18next';

import { AUTOMATA_OFF, SHIFT_STATUS_ONGOING } from '../constants.ts';
import { ServiceAnomaly } from '../schema/Alert.ts';
import { NodeType } from '../schema/Node.ts';
import { Territory } from '../schema/Territory.ts';
import { IVehicle } from '../schema/Vehicle.ts';

export function getServiceHealth(
  territory: Territory,
  vehicles: IVehicle[],
  geography: NodeType[],
): ServiceAnomaly[] {
  const anomalies: ServiceAnomaly[] = [];
  const territoryProviderHealthList = Object.entries(territory.providers_health);
  for (const providerHealth of territoryProviderHealthList) {
    if (!providerHealth[1]) {
      anomalies.push({
        level: 'danger',
        img: 'red-warning.svg',
        text: `${providerHealth[0]} : ${t('service-health.connection-not-healthy')}`,
        helpText: `${t('service-health.connection-not-healthy-tips')}`,
        contentObject: territory.slug,
      });
    }
  }
  for (const vehicle of vehicles) {
    if (vehicle?.shift?.status === SHIFT_STATUS_ONGOING && !vehicle?.is_online) {
      anomalies.push({
        level: 'warning',
        img: 'orange-warning.svg',
        text: t('service-health.disconnected-with-ongoing-shift'),
        contentObject: vehicle.display_identifier,
        helpText: t('service-health.disconnected-with-ongoing-shift-tips'),
      });
    }
    if (vehicle?.shift?.status === SHIFT_STATUS_ONGOING && vehicle?.automata_state === AUTOMATA_OFF) {
      anomalies.push({
        level: 'warning',
        img: 'orange-warning.svg',
        text: t('service-health.automata-off-with-ongoing-shift'),
        contentObject: vehicle.display_identifier,
        helpText: t('service-health.automata-off-with-ongoing-shift-tips'),
      });
    }
  }
  for (const node of geography) {
    if (node.name === null) {
      anomalies.push({
        level: 'warning',
        img: 'orange-warning.svg',
        text: `${node.name} : ${t('service-health.geography-node-is-not-mapped')}`,
        contentObject: territory.slug,
        helpText: t('service-health.geography-node-is-not-mapped-tips'),
      });
    }
  }
  return anomalies;
}
